import type { InternalAxiosRequestConfig } from 'axios'
import { useAuthStore } from '../stores/authStore'
import { i18n } from '../i18n'

/**
 * Request interceptor to add auth token and language header
 */
export function setupRequestInterceptor(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
  // Add auth token if available
  const token = useAuthStore.getState().token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  
  // Add language header from i18n
  const language = i18n.getCurrentLanguage()
  config.headers['X-Language'] = language
  
  return config
}

/**
 * Request error handler
 */
export function handleRequestError(error: any): Promise<never> {
  return Promise.reject(error)
}

